package ir.site.zero1plus.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.icons.fa.FaMoon
import com.varabyte.kobweb.silk.components.icons.fa.FaSun
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import ir.site.zero1plus.helper.colorModeDetect
import ir.site.zero1plus.theme.SurfaceDark
import ir.site.zero1plus.theme.SurfaceLight
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

val ThemeButtonStyle = CssStyle {
    base {
        Modifier.backgroundColor(colorModeDetect(darkMode = SurfaceDark, lightMode = SurfaceLight))
            .borderRadius(50.percent)
            .padding(0.px)
    }

}


@Composable
fun ThemeButton() {
    var colorMode by ColorMode.currentState
    Button(
        onClick = { colorMode = colorMode.opposite },
        modifier = ThemeButtonStyle.toModifier()
    ) {
        if (colorMode.isLight) FaMoon() else FaSun()
    }
}